// @flow

import actionCreators from "@modules/profile/actionCreator";
import http from "@http";
import type { Action } from "redux-action";
import {
  GetAdviceLibraryCategories,
  GetAdviceLibraryTopic,
} from "@modules/profile/constants/actions";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type {
  AdviceLibraryCategory,
  AdviceLibraryTopic,
} from "@modules/profile/reducer/advice-library/types";

export function* onGetAdviceLibraryCategories(): Generator<
  *,
  void,
  { data: Array<AdviceLibraryCategory> },
> {
  try {
    const response = yield call(http.get, "api/v2/advice/category");

    yield put(actionCreators.GetAdviceLibraryCategoriesSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAdviceLibraryCategoriesError(e.response));
  }
}

type TopicGetRequest = $Exact<{
  topicId: number,
}>;

export function* onGetAdviceLibraryTopic({
  payload,
}: Action<TopicGetRequest>): Generator<*, void, { data: AdviceLibraryTopic }> {
  try {
    if (!payload || !payload.topicId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(http.get, `api/v1/advice/topic/${payload.topicId}`);

    yield put(actionCreators.GetAdviceLibraryTopicSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAdviceLibraryTopicError(e.response));
  }
}

export default function* AdviceLibrarySaga(): Generator<*, void, void> {
  yield all([takeEvery(GetAdviceLibraryCategories, onGetAdviceLibraryCategories)]);
  yield all([takeEvery(GetAdviceLibraryTopic, onGetAdviceLibraryTopic)]);
}
